import React from 'react'
import Text from 'components/elements/texts/Text'
import styled from 'styled-components'

/** InformationNoteのタイプ定義 */
export type InformationNoteProps = {
  /** タイトル */
  title: string
  /** 文言リスト */
  notes: Array<string>
}

/**
 * 注釈ノート表示コンポーネント
 */
const InformationNote: React.FC<InformationNoteProps> = (props) => {
  const { title, notes } = props
  return (
    <NoteArea>
      {title && (
        <NoteTitle>
          <Text bold>{title}</Text>
        </NoteTitle>
      )}
      {notes && (
        <NoteList>
          {notes.map((note, index) => (
            <li key={index}>
              <Text>{note}</Text>
            </li>
          ))}
        </NoteList>
      )}
    </NoteArea>
  )
}

const NoteArea = styled.div`
  margin: 22px 0 6px;
  padding: 0 16px;
  background: var(--color-content-background);
`

const NoteTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  &&:before {
    margin-right: 8px;
  }
  &&:after {
    margin-left: 8px;
  }
  &&:before,
  &&:after {
    flex: 1;
    height: 0;
    border-top: 1px solid var(--color-text);
    content: '';
  }
`

const NoteList = styled.ul`
  margin: 6px 8px 8px;
  padding-left: 16px;
`

export default React.memo<InformationNoteProps>(InformationNote)
